import { z } from 'zod'

// The enforced CSP has no 'unsafe-eval': jitless stops Zod from probing new Function() when it builds a schema.
z.config({ jitless: true })
